module.exports = __webpack_public_path__ + "img/81.8face109.jpg";